import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './ModelDropdown.module.css';
import { setModel } from '../../redux/shared/actions.js';
import Selection from './Selection.svg';

const AdvisorDropdown = () => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const modelName = useSelector((state) => state.shared.model_name)

  const modelList = ['AE Academic Advisor', 'IE Academic Advisor', 'ECE Academic Advisor']

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  const handleChangeModel = (modelName) => {
    dispatch(setModel(modelName))
    localStorage.setItem('model_name', modelName)
    setIsOpen(!isOpen)
  }

  return (
    <div className={styles.container}>
      <button className={styles.dropdown} onClick={handleDropdownClick}>
        {modelName}
        <img
            src={Selection}
            alt="Selection"
            className={styles.selection}
          />
      </button>

      {isOpen && (
        <div className={styles.content}>
          {modelList.map((model, index) => (
            <button 
              className={styles.dropbutton} 
              onClick={() => handleChangeModel(model)}
            >
              {model}
            </button>
          ))}
          <div className={styles.dropdownsubtext}>
            Contact <a href='mailto:wgay7@gatech.edu'>William Gay</a> to create your school's model!  
          </div>
          
        </div>
      )}
    </div>
  );
};

export default AdvisorDropdown;